var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "phone-list-component" }, [
    _c("span", { staticClass: "info-item-label" }, [
      _vm._v(_vm._s(`${_vm.label}:`)),
    ]),
    _c(
      "ul",
      { ref: "phoneListRef", staticClass: "info-item-data-large" },
      _vm._l(_vm.data, function (subItem, subIndex) {
        return _c("li", { key: subIndex }, [
          _c("span", { staticClass: "subitem-name" }, [
            _vm._v(_vm._s(subItem.name)),
          ]),
          subItem.phone
            ? _c("div", { staticClass: "phone-container" }, [
                _c(
                  "a",
                  {
                    staticClass: "phone-link",
                    attrs: { href: `tel:${subItem.phone}` },
                  },
                  [
                    _c("span", { class: [_setup.icon.phone, "phone-icon"] }),
                    _c("span", { staticClass: "phone-number" }, [
                      _vm._v(_vm._s(subItem.phone)),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }